import React, { useEffect, useState } from "react";

function NoInternet(props) {
  const [isOnline, setOnline] = useState(true);

  useEffect(() => {
    setOnline(navigator.onLine);
  }, []);

  window.addEventListener("online", () => {
    setOnline(true);
  });

  window.addEventListener("offline", () => {
    setOnline(false);
  });
  if (isOnline) {
    return props.children;
  } else {
    return (
      <section className="section-padding-normal no-internet-page">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="hide-on-mobile">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="100%"
                  height="477"
                  viewBox="0 0 903.129 477"
                >
                  <defs>
                    <clipPath id="clip-path">
                      <path
                        id="Path_119"
                        data-name="Path 119"
                        d="M851.942,1018.107a1.384,1.384,0,0,0,1.816.732l4.139-1.76a1.384,1.384,0,0,0,.732-1.816l-.255-.6,3.451-1.467a3.554,3.554,0,0,0,1.88-4.662l-10.147-23.866a3.554,3.554,0,0,0-4.662-1.88l-3.451,1.467-.255-.6a1.385,1.385,0,0,0-1.816-.732l-4.138,1.76a1.384,1.384,0,0,0-.733,1.816l.255.6-1.956.831-.255-.6a1.384,1.384,0,0,0-1.816-.732l-4.138,1.76a1.384,1.384,0,0,0-.733,1.816l.255.6-24.324,10.341a3.554,3.554,0,0,0-1.88,4.662l10.147,23.866a3.554,3.554,0,0,0,4.662,1.88l24.324-10.341.255.6a1.384,1.384,0,0,0,1.816.732l4.139-1.76a1.385,1.385,0,0,0,.732-1.816l-.255-.6,1.955-.831Z"
                        transform="translate(-803.629 -982.505)"
                        fill="#fffaeb"
                      />
                    </clipPath>
                    <clipPath id="clip-path-2">
                      <path
                        id="Path_124"
                        data-name="Path 124"
                        d="M1890.423,568.482l9.7,21.01a3.2,3.2,0,0,1-1.562,4.24l-62.349,28.78a3.2,3.2,0,0,1-4.24-1.562l-9.7-21.01a3.2,3.2,0,0,1,1.562-4.24l62.349-28.78A3.2,3.2,0,0,1,1890.423,568.482Z"
                        transform="translate(-1821.978 -566.625)"
                        fill="#fff8e5"
                      />
                    </clipPath>
                  </defs>
                  <g
                    id="Group_1410"
                    data-name="Group 1410"
                    transform="translate(-231.436 -214)"
                  >
                    <g
                      id="Group_23"
                      data-name="Group 23"
                      transform="translate(231.436 214)"
                    >
                      <circle
                        id="Ellipse_1"
                        data-name="Ellipse 1"
                        cx="90.994"
                        cy="90.994"
                        r="90.994"
                        transform="translate(381.801 123.194)"
                        fill="#e8ae1b"
                        opacity="0.08"
                      />
                      <circle
                        id="Ellipse_2"
                        data-name="Ellipse 2"
                        cx="90.994"
                        cy="90.994"
                        r="90.994"
                        transform="translate(378.144 120.037)"
                        fill="#fffbf0"
                      />
                      <g id="Group_13" data-name="Group 13">
                        <path
                          id="Path_116"
                          data-name="Path 116"
                          d="M-668.124,37.179l17.955-7.633-9.24-21.734-17.954,7.634-.453-1.066a3.554,3.554,0,0,0-4.662-1.88l-3.451,1.467-.255-.6A1.385,1.385,0,0,0-688,12.633l-4.139,1.76a1.385,1.385,0,0,0-.733,1.816l.255.6-1.956.832-.255-.6a1.385,1.385,0,0,0-1.816-.732l-4.138,1.76a1.384,1.384,0,0,0-.732,1.816l.255.6-24.324,10.341a3.554,3.554,0,0,0-1.88,4.662l2.278,5.358-8.074,3.433,1.419,3.336C-752.017,56.3-774.71,65.841-796.72,66.469c-9.422.269-27.707-3.218-44.291-29.605a182.252,182.252,0,0,1-11.2-21.513c-.52-1.144-1.024-2.368-1.558-3.664-2.568-6.233-5.479-13.3-12.275-16.725-9.709-4.9-18.378.608-25.344,5.031-.847.538-1.682,1.068-2.507,1.572-2.222,1.358-4.51,2.832-6.722,4.257-11.651,7.5-23.7,15.264-36.773,13.971-11.793-1.166-22.32-8.965-28.159-20.863-11.681-23.8-9.743-47.882,5.928-73.609,13.812-22.675,35.706-42.757,55.022-60.474,2.922-2.68,5.682-5.212,8.387-7.727,5.5-5.111,11.693-11.2,15.652-18.811,4.507-8.663,5.23-17.965,1.983-25.519-2.776-6.464-8.6-11.977-17.315-16.388a83.187,83.187,0,0,0-44.606-8.936c-13.449,1.043-27.673,5.3-42.277,12.654-26.109,13.146-49.434,33.682-70.75,53.915l-15.168,14.4,4.72,4.972,15.168-14.4c20.935-19.872,43.8-40.018,69.113-52.764,13.8-6.95,27.169-10.968,39.725-11.942a76.426,76.426,0,0,1,40.978,8.218c7.24,3.666,11.989,8.032,14.114,12.979,2.4,5.573,1.735,12.918-1.766,19.648-3.455,6.641-9.161,12.234-14.239,16.955-2.688,2.5-5.439,5.023-8.353,7.7-19.652,18.025-41.925,38.455-56.243,61.96C-973.428-65.2-978-52.78-979.442-40.287c-1.646,14.212.957,28.423,7.736,42.237a48.992,48.992,0,0,0,4.537,7.491c7.211,9.785,17.634,16.04,29.1,17.174,15.452,1.528,29.11-7.269,41.16-15.03,2.28-1.468,4.433-2.855,6.586-4.171.857-.524,1.725-1.075,2.605-1.634,7.459-4.736,12.783-7.622,18.582-4.7,4.518,2.277,6.809,7.838,9.024,13.216.533,1.295,1.085,2.633,1.656,3.89a188.456,188.456,0,0,0,11.64,22.324c7.9,12.565,24.932,33.534,50.291,32.81,23.293-.665,46.631-10.475,67.365-19.4l1.431,3.367,8.075-3.433,2.337,5.5a3.554,3.554,0,0,0,4.662,1.88l24.324-10.341.255.6a1.384,1.384,0,0,0,1.816.732l4.139-1.76a1.385,1.385,0,0,0,.732-1.816l-.255-.6,1.956-.831.255.6a1.385,1.385,0,0,0,1.816.733l4.139-1.76a1.385,1.385,0,0,0,.732-1.816l-.255-.6,3.451-1.467a3.554,3.554,0,0,0,1.88-4.662Z"
                          transform="translate(1068.695 219.053)"
                          fill="#ebc86e"
                          opacity="0.31"
                        />
                        <g
                          id="Group_12"
                          data-name="Group 12"
                          transform="translate(0.165)"
                        >
                          <g
                            id="Group_11"
                            data-name="Group 11"
                            transform="translate(335.435 220.163)"
                          >
                            <g
                              id="Group_10"
                              data-name="Group 10"
                              transform="translate(6.356 0)"
                            >
                              <g id="Group_9" data-name="Group 9">
                                <g
                                  id="Group_7"
                                  data-name="Group 7"
                                  transform="translate(0 4.403)"
                                >
                                  <path
                                    id="Path_117"
                                    data-name="Path 117"
                                    d="M851.942,1018.107a1.384,1.384,0,0,0,1.816.732l4.139-1.76a1.384,1.384,0,0,0,.732-1.816l-.255-.6,3.451-1.467a3.554,3.554,0,0,0,1.88-4.662l-10.147-23.866a3.554,3.554,0,0,0-4.662-1.88l-3.451,1.467-.255-.6a1.385,1.385,0,0,0-1.816-.732l-4.138,1.76a1.384,1.384,0,0,0-.733,1.816l.255.6-1.956.831-.255-.6a1.384,1.384,0,0,0-1.816-.732l-4.138,1.76a1.384,1.384,0,0,0-.733,1.816l.255.6-24.324,10.341a3.554,3.554,0,0,0-1.88,4.662l10.147,23.866a3.554,3.554,0,0,0,4.662,1.88l24.324-10.341.255.6a1.384,1.384,0,0,0,1.816.732l4.139-1.76a1.385,1.385,0,0,0,.732-1.816l-.255-.6,1.955-.831Z"
                                    transform="translate(-803.629 -982.505)"
                                    fill="#f5eeda"
                                  />
                                  <g
                                    id="Group_6"
                                    data-name="Group 6"
                                    clipPath="url(#clip-path)"
                                  >
                                    <path
                                      id="Path_118"
                                      data-name="Path 118"
                                      d="M783.646,988.87l53.442-22.53-10.139-18.963-53.886,23.657,4.859,12.732,5.724,5.1"
                                      transform="translate(-778.645 -953.792)"
                                      fill="#e3c67c"
                                      opacity="0.14"
                                    />
                                  </g>
                                </g>
                                <rect
                                  id="Rectangle_3"
                                  data-name="Rectangle 3"
                                  width="23.617"
                                  height="19.51"
                                  transform="matrix(0.391, 0.92, -0.92, 0.391, 68.338, 0)"
                                  fill="#ebc86e"
                                />
                                <g
                                  id="Group_8"
                                  data-name="Group 8"
                                  transform="translate(62.982 1.719)"
                                >
                                  <rect
                                    id="Rectangle_4"
                                    data-name="Rectangle 4"
                                    width="3.527"
                                    height="4.843"
                                    transform="matrix(0.391, 0.92, -0.92, 0.391, 4.457, 0)"
                                    fill="#fff"
                                  />
                                  <rect
                                    id="Rectangle_5"
                                    data-name="Rectangle 5"
                                    width="3.527"
                                    height="4.843"
                                    transform="matrix(0.391, 0.92, -0.92, 0.391, 6.761, 5.419)"
                                    fill="#fff"
                                  />
                                  <rect
                                    id="Rectangle_6"
                                    data-name="Rectangle 6"
                                    width="3.527"
                                    height="4.843"
                                    transform="matrix(0.391, 0.92, -0.92, 0.391, 9.066, 10.839)"
                                    fill="#fff"
                                  />
                                  <rect
                                    id="Rectangle_7"
                                    data-name="Rectangle 7"
                                    width="3.527"
                                    height="4.843"
                                    transform="translate(11.37 16.258) rotate(66.966)"
                                    fill="#fff"
                                  />
                                </g>
                              </g>
                              <rect
                                id="Rectangle_8"
                                data-name="Rectangle 8"
                                width="33.042"
                                height="2.125"
                                transform="matrix(0.391, 0.92, -0.92, 0.391, 35.13, 8.997)"
                                fill="#ebc86e"
                              />
                            </g>
                            <rect
                              id="Rectangle_9"
                              data-name="Rectangle 9"
                              width="14.139"
                              height="9.443"
                              transform="translate(8.69 33.211) rotate(66.967)"
                              fill="#ebc86e"
                            />
                          </g>
                          <path
                            id="Path_120"
                            data-name="Path 120"
                            d="M-966.268-24.841a48.985,48.985,0,0,1-4.537-7.491c-6.779-13.814-9.382-28.025-7.736-42.237,1.447-12.492,6.014-24.909,13.963-37.958,14.318-23.505,36.591-43.935,56.243-61.96,2.913-2.672,5.665-5.2,8.353-7.7,5.077-4.721,10.783-10.313,14.239-16.955,3.5-6.73,4.162-14.075,1.766-19.648-2.125-4.946-6.874-9.313-14.114-12.979a76.428,76.428,0,0,0-40.978-8.218c-12.556.974-25.921,4.992-39.725,11.942-25.315,12.746-48.177,32.892-69.113,52.764l-15.168,14.4-4.72-4.972,15.168-14.4c21.316-20.234,44.64-40.77,70.75-53.915,14.6-7.353,28.828-11.61,42.277-12.654a83.187,83.187,0,0,1,44.605,8.936c8.712,4.411,14.539,9.923,17.316,16.388,3.247,7.555,2.524,16.856-1.983,25.519-3.96,7.61-10.156,13.7-15.653,18.811-2.7,2.515-5.465,5.046-8.387,7.727-19.316,17.717-41.21,37.8-55.022,60.474-15.671,25.726-17.61,49.8-5.928,73.609,5.838,11.9,16.365,19.7,28.159,20.863,13.074,1.293,25.122-6.467,36.773-13.971,2.213-1.425,4.5-2.9,6.723-4.257.824-.5,1.659-1.034,2.506-1.572,6.966-4.423,15.635-9.927,25.344-5.031,6.8,3.428,9.707,10.492,12.275,16.726.534,1.3,1.038,2.52,1.559,3.664a182.223,182.223,0,0,0,11.2,21.513c16.584,26.387,34.869,29.874,44.291,29.605,22.6-.645,45.921-10.69,66.5-19.553l2.98-1.282,2.707,6.3-2.974,1.28c-21.141,9.106-45.1,19.427-69.013,20.11-25.358.724-42.393-20.244-50.291-32.81a188.5,188.5,0,0,1-11.64-22.324c-.571-1.256-1.123-2.6-1.656-3.89-2.215-5.377-4.506-10.938-9.024-13.216-5.8-2.925-11.123-.039-18.582,4.7-.88.559-1.749,1.11-2.606,1.634-2.153,1.316-4.306,2.7-6.586,4.171-12.05,7.761-25.708,16.558-41.16,15.03C-948.634-8.8-959.057-15.056-966.268-24.841Z"
                            transform="translate(1067.793 247.074)"
                            fill="#ebc86e"
                          />
                        </g>
                      </g>
                      <g
                        id="Group_20"
                        data-name="Group 20"
                        transform="translate(504.447 43.426)"
                      >
                        <path
                          id="Path_121"
                          data-name="Path 121"
                          d="M2091.577,280.491c-11,.062-25.35-7.331-32.61-23.986-8.959-20.549-4.3-42.67.2-64.062q.516-2.45,1.021-4.881l.257-1.242c5.121-24.754,10.418-50.356,10.5-76.128A116.441,116.441,0,0,0,2062.128,65c-6.866-16.047-17.3-27.879-30.162-34.218-12.067-5.946-25.617-6.524-36.247-1.547-9.47,4.433-15.887,12.616-18.559,23.664-4.415,18.258-.81,37.334,2.675,55.784.448,2.368.892,4.717,1.313,7.042q.342,1.889.7,3.811c4.875,26.592,10.4,56.732-7.339,78.922-5.43,6.79-11.51,10.327-18.588,10.813-18.5,1.27-39.628-18.776-56.6-34.883-6.616-6.278-12.33-11.7-17.182-15.221-30.625-22.216-58.03-29.411-83.651-21.933l-2.093-4.534-9.59,4.427-1.944-4.212a3.2,3.2,0,0,0-4.24-1.562l-24.52,11.319-.478-1.034a1.654,1.654,0,0,0-2.195-.808l-24.2,11.17a1.654,1.654,0,0,0-.809,2.195l.477,1.034-10.628,4.906a3.2,3.2,0,0,0-1.562,4.24l3.19,6.91-24.3,11.287a3.9,3.9,0,0,0,3.265,7.074l24.313-11.26,3.231,7a3.2,3.2,0,0,0,4.24,1.562l10.628-4.906.478,1.034a1.654,1.654,0,0,0,2.195.808l24.2-11.17a1.654,1.654,0,0,0,.808-2.195l-.477-1.034,24.52-11.318a3.2,3.2,0,0,0,1.562-4.24l-1.452-3.146-.492-1.066,9.59-4.427-2.34-5.069c24.47-6.947,50.805.136,80.365,21.58,4.679,3.394,10.321,8.748,16.854,14.948,17.436,16.545,39.135,37.136,59.062,35.768,7.925-.544,14.957-4.59,20.9-12.026,18.667-23.346,13-54.262,8-81.538q-.351-1.917-.7-3.8c-.423-2.333-.868-4.689-1.317-7.065-3.421-18.112-6.962-36.838-2.709-54.416,2.431-10.055,8.233-17.485,16.777-21.485,9.745-4.562,22.243-3.994,33.433,1.519,12.16,5.992,22.053,17.258,28.61,32.582a113.119,113.119,0,0,1,8.561,43.9c-.084,25.444-5.347,50.883-10.437,75.48l-.257,1.242q-.5,2.425-1.019,4.87c-4.609,21.894-9.374,44.529,0,66.031a47.091,47.091,0,0,0,14.2,18.282,34.851,34.851,0,0,0,21.413,7.655Z"
                          transform="translate(-1693.33 -19.45)"
                          fill="#ebc86e"
                          opacity="0.31"
                        />
                        <g
                          id="Group_19"
                          data-name="Group 19"
                          transform="translate(0.416 0)"
                        >
                          <g
                            id="Group_18"
                            data-name="Group 18"
                            transform="translate(0 105.185)"
                          >
                            <g id="Group_17" data-name="Group 17">
                              <g
                                id="Group_15"
                                data-name="Group 15"
                                transform="translate(23.08)"
                              >
                                <path
                                  id="Path_122"
                                  data-name="Path 122"
                                  d="M1890.423,568.482l9.7,21.01a3.2,3.2,0,0,1-1.562,4.24l-62.349,28.78a3.2,3.2,0,0,1-4.24-1.562l-9.7-21.01a3.2,3.2,0,0,1,1.562-4.24l62.349-28.78A3.2,3.2,0,0,1,1890.423,568.482Z"
                                  transform="translate(-1821.978 -566.625)"
                                  fill="#fff9ea"
                                />
                                <g
                                  id="Group_14"
                                  data-name="Group 14"
                                  clipPath="url(#clip-path-2)"
                                >
                                  <path
                                    id="Path_123"
                                    data-name="Path 123"
                                    d="M1872.795,551.552l-73.739,33.189-5.988-18.408,26.171-19.517,50.123-13.751Z"
                                    transform="translate(-1798.347 -539.194)"
                                    fill="#ebc86e"
                                    opacity="0.14"
                                  />
                                </g>
                              </g>
                              <path
                                id="Path_125"
                                data-name="Path 125"
                                d="M1914.239,620.25l13.331,28.879a1.654,1.654,0,0,1-.808,2.195l-24.2,11.17a1.654,1.654,0,0,1-2.195-.809l-13.331-28.879a1.654,1.654,0,0,1,.808-2.195l24.2-11.169A1.654,1.654,0,0,1,1914.239,620.25Z"
                                transform="translate(-1851.951 -609.671)"
                                fill="#ebc86e"
                              />
                              <g
                                id="Group_16"
                                data-name="Group 16"
                                transform="translate(37.994 12.959)"
                              >
                                <path
                                  id="Path_126"
                                  data-name="Path 126"
                                  d="M1989.045,772.831h0a1.189,1.189,0,0,1-.581,1.578l-21.029,9.707a1.189,1.189,0,0,1-1.578-.581h0a1.189,1.189,0,0,1,.581-1.578l21.029-9.707A1.189,1.189,0,0,1,1989.045,772.831Z"
                                  transform="translate(-1954.403 -747.565)"
                                  fill="#fffcf5"
                                />
                                <path
                                  id="Path_127"
                                  data-name="Path 127"
                                  d="M1976.622,745.919h0a1.189,1.189,0,0,1-.581,1.578l-21.029,9.707a1.189,1.189,0,0,1-1.578-.581h0a1.189,1.189,0,0,1,.581-1.578l21.029-9.707A1.189,1.189,0,0,1,1976.622,745.919Z"
                                  transform="translate(-1944.249 -725.568)"
                                  fill="#fffcf5"
                                />
                                <path
                                  id="Path_128"
                                  data-name="Path 128"
                                  d="M1964.2,719.007h0a1.189,1.189,0,0,1-.581,1.578l-21.029,9.707a1.189,1.189,0,0,1-1.578-.581h0a1.189,1.189,0,0,1,.581-1.578l21.029-9.707A1.189,1.189,0,0,1,1964.2,719.007Z"
                                  transform="translate(-1934.095 -703.571)"
                                  fill="#fffcf5"
                                />
                                <path
                                  id="Path_129"
                                  data-name="Path 129"
                                  d="M1951.777,692.095h0a1.189,1.189,0,0,1-.581,1.578l-21.029,9.707a1.189,1.189,0,0,1-1.578-.581h0a1.189,1.189,0,0,1,.581-1.578l21.029-9.707A1.189,1.189,0,0,1,1951.777,692.095Z"
                                  transform="translate(-1923.942 -681.574)"
                                  fill="#fffcf5"
                                />
                                <path
                                  id="Path_130"
                                  data-name="Path 130"
                                  d="M1939.354,665.184h0a1.189,1.189,0,0,1-.582,1.578l-21.029,9.707a1.189,1.189,0,0,1-1.578-.581h0a1.189,1.189,0,0,1,.581-1.578l21.029-9.707A1.189,1.189,0,0,1,1939.354,665.184Z"
                                  transform="translate(-1913.788 -659.578)"
                                  fill="#fffcf5"
                                />
                                <path
                                  id="Path_131"
                                  data-name="Path 131"
                                  d="M1926.931,638.271h0a1.189,1.189,0,0,1-.581,1.578l-21.029,9.707a1.189,1.189,0,0,1-1.578-.581h0a1.189,1.189,0,0,1,.581-1.578l21.029-9.707A1.189,1.189,0,0,1,1926.931,638.271Z"
                                  transform="translate(-1903.634 -637.581)"
                                  fill="#fffcf5"
                                />
                              </g>
                              <path
                                id="Path_132"
                                data-name="Path 132"
                                d="M1722.2,787.187l3.265,7.074-24.328,11.23a3.9,3.9,0,0,1-5.169-1.9h0a3.9,3.9,0,0,1,1.9-5.169Z"
                                transform="translate(-1695.606 -746.904)"
                                fill="#e6cc89"
                              />
                            </g>
                            <rect
                              id="Rectangle_10"
                              data-name="Rectangle 10"
                              width="13.863"
                              height="10.562"
                              transform="translate(99.279 18.655) rotate(-114.778)"
                              fill="#ebc86e"
                            />
                          </g>
                          <path
                            id="Path_133"
                            data-name="Path 133"
                            d="M2253.521,103.09c26.554-9.094,54.981-2.257,86.907,20.9,4.852,3.52,10.566,8.942,17.182,15.221,16.974,16.107,38.1,36.153,56.6,34.883,7.078-.486,13.158-4.023,18.588-10.813,17.741-22.19,12.215-52.33,7.339-78.922q-.352-1.921-.7-3.811c-.422-2.325-.866-4.674-1.313-7.042-3.485-18.45-7.089-37.526-2.675-55.784,2.672-11.048,9.089-19.231,18.559-23.664,10.63-4.977,24.18-4.4,36.248,1.547,12.866,6.339,23.3,18.172,30.162,34.218a116.437,116.437,0,0,1,8.823,45.191c-.085,25.772-5.382,51.374-10.5,76.128l-.257,1.242q-.5,2.431-1.022,4.881c-4.5,21.392-9.16,43.513-.2,64.062,7.26,16.655,21.61,24.048,32.61,23.986l.018,3.25a34.851,34.851,0,0,1-21.413-7.655,47.091,47.091,0,0,1-14.2-18.282c-9.374-21.5-4.609-44.137,0-66.031q.514-2.444,1.019-4.869l.257-1.242c5.09-24.6,10.353-50.036,10.436-75.48a113.115,113.115,0,0,0-8.561-43.9c-6.556-15.324-16.45-26.59-28.61-32.582-11.19-5.513-23.688-6.082-33.433-1.519-8.544,4-14.346,11.429-16.777,21.485-4.253,17.578-.712,36.3,2.709,54.416.449,2.376.894,4.733,1.317,7.065q.343,1.886.7,3.8c5,27.276,10.669,58.192-8,81.538-5.947,7.436-12.979,11.482-20.9,12.026-19.927,1.368-41.626-19.223-59.062-35.768-6.533-6.2-12.175-11.553-16.854-14.948-31.006-22.494-58.465-29.186-83.945-20.46Z"
                            transform="translate(-2151.625 9.299)"
                            fill="#ebc86e"
                          />
                        </g>
                      </g>
                      <g
                        id="Group_21"
                        data-name="Group 21"
                        transform="translate(460.544 147.089)"
                      >
                        <path
                          id="Path_134"
                          data-name="Path 134"
                          d="M1456.1,661.043a5.885,5.885,0,0,1,3.137-3.137,5.983,5.983,0,0,1,4.6,0,5.884,5.884,0,0,1,3.137,3.137,5.984,5.984,0,0,1,0,4.6,5.887,5.887,0,0,1-3.137,3.137,5.984,5.984,0,0,1-4.6,0,5.888,5.888,0,0,1-3.137-3.137,5.984,5.984,0,0,1,0-4.6Zm14.032-92.679q0-5.037-1.926-7.557t-6.668-2.519q-4.742,0-6.668,2.519t-1.926,7.557v30.286l4.445,45.1v-.119a4.128,4.128,0,0,0,1.541,3.082,4.534,4.534,0,0,0,5.186.03,4.016,4.016,0,0,0,1.511-2.993l4.5-45.1Z"
                          transform="translate(-1452.945 -558.289)"
                          fill="#f0d388"
                        />
                      </g>
                      <rect
                        id="Rectangle_11"
                        data-name="Rectangle 11"
                        width="547.278"
                        height="369.726"
                        transform="translate(195.487 45.274)"
                        fill="none"
                      />
                    </g>
                    <text
                      id="No_Internet_Connection_Please_Try_again"
                      data-name="No Internet Connection
  Please Try again"
                      transform="translate(683 640)"
                      fill="#ebc86e"
                      fontSize="35"
                      fontFamily="AlbertSans-Bold, Albert Sans"
                      fontWeight="700"
                      letterSpacing="-0.04em"
                    >
                      <tspan x="-174.895" y="0">
                        No Internet Connection
                      </tspan>
                      <tspan x="-122.027" y="42">
                        Please Try again
                      </tspan>
                    </text>
                  </g>
                </svg>
              </div>
              <div className="hide-on-desktop">
                <svg
                  id="Group_1411"
                  data-name="Group 1411"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="100%"
                  height="926"
                  viewBox="0 0 428 926"
                >
                  <defs>
                    <clipPath id="clip-path">
                      <rect
                        id="Rectangle_168"
                        data-name="Rectangle 168"
                        width="428"
                        height="926"
                        fill="rgba(255,255,255,0)"
                      />
                    </clipPath>
                    <clipPath id="clip-path-2">
                      <path
                        id="Path_119"
                        data-name="Path 119"
                        d="M851.942,1018.107a1.384,1.384,0,0,0,1.816.732l4.139-1.76a1.384,1.384,0,0,0,.732-1.816l-.255-.6,3.451-1.467a3.554,3.554,0,0,0,1.88-4.662l-10.147-23.866a3.554,3.554,0,0,0-4.662-1.88l-3.451,1.467-.255-.6a1.385,1.385,0,0,0-1.816-.732l-4.138,1.76a1.384,1.384,0,0,0-.733,1.816l.255.6-1.956.831-.255-.6a1.384,1.384,0,0,0-1.816-.732l-4.138,1.76a1.384,1.384,0,0,0-.733,1.816l.255.6-24.324,10.341a3.554,3.554,0,0,0-1.88,4.662l10.147,23.866a3.554,3.554,0,0,0,4.662,1.88l24.324-10.341.255.6a1.384,1.384,0,0,0,1.816.732l4.139-1.76a1.385,1.385,0,0,0,.732-1.816l-.255-.6,1.955-.831Z"
                        transform="translate(-803.629 -982.505)"
                        fill="#fffaeb"
                      />
                    </clipPath>
                    <clipPath id="clip-path-3">
                      <path
                        id="Path_124"
                        data-name="Path 124"
                        d="M1890.423,568.482l9.7,21.01a3.2,3.2,0,0,1-1.562,4.24l-62.349,28.78a3.2,3.2,0,0,1-4.24-1.562l-9.7-21.01a3.2,3.2,0,0,1,1.562-4.24l62.349-28.78A3.2,3.2,0,0,1,1890.423,568.482Z"
                        transform="translate(-1821.978 -566.625)"
                        fill="#fff8e5"
                      />
                    </clipPath>
                  </defs>
                  <g
                    id="Mask_Group_50"
                    data-name="Mask Group 50"
                    clipPath="url(#clip-path)"
                  >
                    <g
                      id="Group_1410"
                      data-name="Group 1410"
                      transform="translate(-469 10.5)"
                    >
                      <g
                        id="Group_23"
                        data-name="Group 23"
                        transform="translate(231.436 214)"
                      >
                        <circle
                          id="Ellipse_1"
                          data-name="Ellipse 1"
                          cx="90.994"
                          cy="90.994"
                          r="90.994"
                          transform="translate(361.801 123.194)"
                          fill="#e8ae1b"
                          opacity="0.08"
                        />
                        <circle
                          id="Ellipse_2"
                          data-name="Ellipse 2"
                          cx="90.994"
                          cy="90.994"
                          r="90.994"
                          transform="translate(358.144 120.037)"
                          fill="#fffbf0"
                        />
                        <g
                          id="Group_13"
                          data-name="Group 13"
                          transform="translate(-20)"
                        >
                          <path
                            id="Path_116"
                            data-name="Path 116"
                            d="M-668.124,37.179l17.955-7.633-9.24-21.734-17.954,7.634-.453-1.066a3.554,3.554,0,0,0-4.662-1.88l-3.451,1.467-.255-.6A1.385,1.385,0,0,0-688,12.633l-4.139,1.76a1.385,1.385,0,0,0-.733,1.816l.255.6-1.956.832-.255-.6a1.385,1.385,0,0,0-1.816-.732l-4.138,1.76a1.384,1.384,0,0,0-.732,1.816l.255.6-24.324,10.341a3.554,3.554,0,0,0-1.88,4.662l2.278,5.358-8.074,3.433,1.419,3.336C-752.017,56.3-774.71,65.841-796.72,66.469c-9.422.269-27.707-3.218-44.291-29.605a182.252,182.252,0,0,1-11.2-21.513c-.52-1.144-1.024-2.368-1.558-3.664-2.568-6.233-5.479-13.3-12.275-16.725-9.709-4.9-18.378.608-25.344,5.031-.847.538-1.682,1.068-2.507,1.572-2.222,1.358-4.51,2.832-6.722,4.257-11.651,7.5-23.7,15.264-36.773,13.971-11.793-1.166-22.32-8.965-28.159-20.863-11.681-23.8-9.743-47.882,5.928-73.609,13.812-22.675,35.706-42.757,55.022-60.474,2.922-2.68,5.682-5.212,8.387-7.727,5.5-5.111,11.693-11.2,15.652-18.811,4.507-8.663,5.23-17.965,1.983-25.519-2.776-6.464-8.6-11.977-17.315-16.388a83.187,83.187,0,0,0-44.606-8.936c-13.449,1.043-27.673,5.3-42.277,12.654-26.109,13.146-49.434,33.682-70.75,53.915l-15.168,14.4,4.72,4.972,15.168-14.4c20.935-19.872,43.8-40.018,69.113-52.764,13.8-6.95,27.169-10.968,39.725-11.942a76.426,76.426,0,0,1,40.978,8.218c7.24,3.666,11.989,8.032,14.114,12.979,2.4,5.573,1.735,12.918-1.766,19.648-3.455,6.641-9.161,12.234-14.239,16.955-2.688,2.5-5.439,5.023-8.353,7.7-19.652,18.025-41.925,38.455-56.243,61.96C-973.428-65.2-978-52.78-979.442-40.287c-1.646,14.212.957,28.423,7.736,42.237a48.992,48.992,0,0,0,4.537,7.491c7.211,9.785,17.634,16.04,29.1,17.174,15.452,1.528,29.11-7.269,41.16-15.03,2.28-1.468,4.433-2.855,6.586-4.171.857-.524,1.725-1.075,2.605-1.634,7.459-4.736,12.783-7.622,18.582-4.7,4.518,2.277,6.809,7.838,9.024,13.216.533,1.295,1.085,2.633,1.656,3.89a188.456,188.456,0,0,0,11.64,22.324c7.9,12.565,24.932,33.534,50.291,32.81,23.293-.665,46.631-10.475,67.365-19.4l1.431,3.367,8.075-3.433,2.337,5.5a3.554,3.554,0,0,0,4.662,1.88l24.324-10.341.255.6a1.384,1.384,0,0,0,1.816.732l4.139-1.76a1.385,1.385,0,0,0,.732-1.816l-.255-.6,1.956-.831.255.6a1.385,1.385,0,0,0,1.816.733l4.139-1.76a1.385,1.385,0,0,0,.732-1.816l-.255-.6,3.451-1.467a3.554,3.554,0,0,0,1.88-4.662Z"
                            transform="translate(1068.695 219.053)"
                            fill="#ebc86e"
                            opacity="0.31"
                          />
                          <g
                            id="Group_12"
                            data-name="Group 12"
                            transform="translate(0.165)"
                          >
                            <g
                              id="Group_11"
                              data-name="Group 11"
                              transform="translate(335.435 220.163)"
                            >
                              <g
                                id="Group_10"
                                data-name="Group 10"
                                transform="translate(6.356 0)"
                              >
                                <g id="Group_9" data-name="Group 9">
                                  <g
                                    id="Group_7"
                                    data-name="Group 7"
                                    transform="translate(0 4.403)"
                                  >
                                    <path
                                      id="Path_117"
                                      data-name="Path 117"
                                      d="M851.942,1018.107a1.384,1.384,0,0,0,1.816.732l4.139-1.76a1.384,1.384,0,0,0,.732-1.816l-.255-.6,3.451-1.467a3.554,3.554,0,0,0,1.88-4.662l-10.147-23.866a3.554,3.554,0,0,0-4.662-1.88l-3.451,1.467-.255-.6a1.385,1.385,0,0,0-1.816-.732l-4.138,1.76a1.384,1.384,0,0,0-.733,1.816l.255.6-1.956.831-.255-.6a1.384,1.384,0,0,0-1.816-.732l-4.138,1.76a1.384,1.384,0,0,0-.733,1.816l.255.6-24.324,10.341a3.554,3.554,0,0,0-1.88,4.662l10.147,23.866a3.554,3.554,0,0,0,4.662,1.88l24.324-10.341.255.6a1.384,1.384,0,0,0,1.816.732l4.139-1.76a1.385,1.385,0,0,0,.732-1.816l-.255-.6,1.955-.831Z"
                                      transform="translate(-803.629 -982.505)"
                                      fill="#f5eeda"
                                    />
                                    <g
                                      id="Group_6"
                                      data-name="Group 6"
                                      clipPath="url(#clip-path-2)"
                                    >
                                      <path
                                        id="Path_118"
                                        data-name="Path 118"
                                        d="M783.646,988.87l53.442-22.53-10.139-18.963-53.886,23.657,4.859,12.732,5.724,5.1"
                                        transform="translate(-778.645 -953.792)"
                                        fill="#e3c67c"
                                        opacity="0.14"
                                      />
                                    </g>
                                  </g>
                                  <rect
                                    id="Rectangle_3"
                                    data-name="Rectangle 3"
                                    width="23.617"
                                    height="19.51"
                                    transform="matrix(0.391, 0.92, -0.92, 0.391, 68.338, 0)"
                                    fill="#ebc86e"
                                  />
                                  <g
                                    id="Group_8"
                                    data-name="Group 8"
                                    transform="translate(62.982 1.719)"
                                  >
                                    <rect
                                      id="Rectangle_4"
                                      data-name="Rectangle 4"
                                      width="3.527"
                                      height="4.843"
                                      transform="matrix(0.391, 0.92, -0.92, 0.391, 4.457, 0)"
                                      fill="#fff"
                                    />
                                    <rect
                                      id="Rectangle_5"
                                      data-name="Rectangle 5"
                                      width="3.527"
                                      height="4.843"
                                      transform="matrix(0.391, 0.92, -0.92, 0.391, 6.761, 5.419)"
                                      fill="#fff"
                                    />
                                    <rect
                                      id="Rectangle_6"
                                      data-name="Rectangle 6"
                                      width="3.527"
                                      height="4.843"
                                      transform="matrix(0.391, 0.92, -0.92, 0.391, 9.066, 10.839)"
                                      fill="#fff"
                                    />
                                    <rect
                                      id="Rectangle_7"
                                      data-name="Rectangle 7"
                                      width="3.527"
                                      height="4.843"
                                      transform="translate(11.37 16.258) rotate(66.966)"
                                      fill="#fff"
                                    />
                                  </g>
                                </g>
                                <rect
                                  id="Rectangle_8"
                                  data-name="Rectangle 8"
                                  width="33.042"
                                  height="2.125"
                                  transform="matrix(0.391, 0.92, -0.92, 0.391, 35.13, 8.997)"
                                  fill="#ebc86e"
                                />
                              </g>
                              <rect
                                id="Rectangle_9"
                                data-name="Rectangle 9"
                                width="14.139"
                                height="9.443"
                                transform="translate(8.69 33.211) rotate(66.967)"
                                fill="#ebc86e"
                              />
                            </g>
                            <path
                              id="Path_120"
                              data-name="Path 120"
                              d="M-966.268-24.841a48.985,48.985,0,0,1-4.537-7.491c-6.779-13.814-9.382-28.025-7.736-42.237,1.447-12.492,6.014-24.909,13.963-37.958,14.318-23.505,36.591-43.935,56.243-61.96,2.913-2.672,5.665-5.2,8.353-7.7,5.077-4.721,10.783-10.313,14.239-16.955,3.5-6.73,4.162-14.075,1.766-19.648-2.125-4.946-6.874-9.313-14.114-12.979a76.428,76.428,0,0,0-40.978-8.218c-12.556.974-25.921,4.992-39.725,11.942-25.315,12.746-48.177,32.892-69.113,52.764l-15.168,14.4-4.72-4.972,15.168-14.4c21.316-20.234,44.64-40.77,70.75-53.915,14.6-7.353,28.828-11.61,42.277-12.654a83.187,83.187,0,0,1,44.605,8.936c8.712,4.411,14.539,9.923,17.316,16.388,3.247,7.555,2.524,16.856-1.983,25.519-3.96,7.61-10.156,13.7-15.653,18.811-2.7,2.515-5.465,5.046-8.387,7.727-19.316,17.717-41.21,37.8-55.022,60.474-15.671,25.726-17.61,49.8-5.928,73.609,5.838,11.9,16.365,19.7,28.159,20.863,13.074,1.293,25.122-6.467,36.773-13.971,2.213-1.425,4.5-2.9,6.723-4.257.824-.5,1.659-1.034,2.506-1.572,6.966-4.423,15.635-9.927,25.344-5.031,6.8,3.428,9.707,10.492,12.275,16.726.534,1.3,1.038,2.52,1.559,3.664a182.223,182.223,0,0,0,11.2,21.513c16.584,26.387,34.869,29.874,44.291,29.605,22.6-.645,45.921-10.69,66.5-19.553l2.98-1.282,2.707,6.3-2.974,1.28c-21.141,9.106-45.1,19.427-69.013,20.11-25.358.724-42.393-20.244-50.291-32.81a188.5,188.5,0,0,1-11.64-22.324c-.571-1.256-1.123-2.6-1.656-3.89-2.215-5.377-4.506-10.938-9.024-13.216-5.8-2.925-11.123-.039-18.582,4.7-.88.559-1.749,1.11-2.606,1.634-2.153,1.316-4.306,2.7-6.586,4.171-12.05,7.761-25.708,16.558-41.16,15.03C-948.634-8.8-959.057-15.056-966.268-24.841Z"
                              transform="translate(1067.793 247.074)"
                              fill="#ebc86e"
                            />
                          </g>
                        </g>
                        <g
                          id="Group_20"
                          data-name="Group 20"
                          transform="translate(484.447 43.426)"
                        >
                          <path
                            id="Path_121"
                            data-name="Path 121"
                            d="M2091.577,280.491c-11,.062-25.35-7.331-32.61-23.986-8.959-20.549-4.3-42.67.2-64.062q.516-2.45,1.021-4.881l.257-1.242c5.121-24.754,10.418-50.356,10.5-76.128A116.441,116.441,0,0,0,2062.128,65c-6.866-16.047-17.3-27.879-30.162-34.218-12.067-5.946-25.617-6.524-36.247-1.547-9.47,4.433-15.887,12.616-18.559,23.664-4.415,18.258-.81,37.334,2.675,55.784.448,2.368.892,4.717,1.313,7.042q.342,1.889.7,3.811c4.875,26.592,10.4,56.732-7.339,78.922-5.43,6.79-11.51,10.327-18.588,10.813-18.5,1.27-39.628-18.776-56.6-34.883-6.616-6.278-12.33-11.7-17.182-15.221-30.625-22.216-58.03-29.411-83.651-21.933l-2.093-4.534-9.59,4.427-1.944-4.212a3.2,3.2,0,0,0-4.24-1.562l-24.52,11.319-.478-1.034a1.654,1.654,0,0,0-2.195-.808l-24.2,11.17a1.654,1.654,0,0,0-.809,2.195l.477,1.034-10.628,4.906a3.2,3.2,0,0,0-1.562,4.24l3.19,6.91-24.3,11.287a3.9,3.9,0,0,0,3.265,7.074l24.313-11.26,3.231,7a3.2,3.2,0,0,0,4.24,1.562l10.628-4.906.478,1.034a1.654,1.654,0,0,0,2.195.808l24.2-11.17a1.654,1.654,0,0,0,.808-2.195l-.477-1.034,24.52-11.318a3.2,3.2,0,0,0,1.562-4.24l-1.452-3.146-.492-1.066,9.59-4.427-2.34-5.069c24.47-6.947,50.805.136,80.365,21.58,4.679,3.394,10.321,8.748,16.854,14.948,17.436,16.545,39.135,37.136,59.062,35.768,7.925-.544,14.957-4.59,20.9-12.026,18.667-23.346,13-54.262,8-81.538q-.351-1.917-.7-3.8c-.423-2.333-.868-4.689-1.317-7.065-3.421-18.112-6.962-36.838-2.709-54.416,2.431-10.055,8.233-17.485,16.777-21.485,9.745-4.562,22.243-3.994,33.433,1.519,12.16,5.992,22.053,17.258,28.61,32.582a113.119,113.119,0,0,1,8.561,43.9c-.084,25.444-5.347,50.883-10.437,75.48l-.257,1.242q-.5,2.425-1.019,4.87c-4.609,21.894-9.374,44.529,0,66.031a47.091,47.091,0,0,0,14.2,18.282,34.851,34.851,0,0,0,21.413,7.655Z"
                            transform="translate(-1693.33 -19.45)"
                            fill="#ebc86e"
                            opacity="0.31"
                          />
                          <g
                            id="Group_19"
                            data-name="Group 19"
                            transform="translate(0.416 0)"
                          >
                            <g
                              id="Group_18"
                              data-name="Group 18"
                              transform="translate(0 105.185)"
                            >
                              <g id="Group_17" data-name="Group 17">
                                <g
                                  id="Group_15"
                                  data-name="Group 15"
                                  transform="translate(23.08)"
                                >
                                  <path
                                    id="Path_122"
                                    data-name="Path 122"
                                    d="M1890.423,568.482l9.7,21.01a3.2,3.2,0,0,1-1.562,4.24l-62.349,28.78a3.2,3.2,0,0,1-4.24-1.562l-9.7-21.01a3.2,3.2,0,0,1,1.562-4.24l62.349-28.78A3.2,3.2,0,0,1,1890.423,568.482Z"
                                    transform="translate(-1821.978 -566.625)"
                                    fill="#fff9ea"
                                  />
                                  <g
                                    id="Group_14"
                                    data-name="Group 14"
                                    clipPath="url(#clip-path-3)"
                                  >
                                    <path
                                      id="Path_123"
                                      data-name="Path 123"
                                      d="M1872.795,551.552l-73.739,33.189-5.988-18.408,26.171-19.517,50.123-13.751Z"
                                      transform="translate(-1798.347 -539.194)"
                                      fill="#ebc86e"
                                      opacity="0.14"
                                    />
                                  </g>
                                </g>
                                <path
                                  id="Path_125"
                                  data-name="Path 125"
                                  d="M1914.239,620.25l13.331,28.879a1.654,1.654,0,0,1-.808,2.195l-24.2,11.17a1.654,1.654,0,0,1-2.195-.809l-13.331-28.879a1.654,1.654,0,0,1,.808-2.195l24.2-11.169A1.654,1.654,0,0,1,1914.239,620.25Z"
                                  transform="translate(-1851.951 -609.671)"
                                  fill="#ebc86e"
                                />
                                <g
                                  id="Group_16"
                                  data-name="Group 16"
                                  transform="translate(37.994 12.959)"
                                >
                                  <path
                                    id="Path_126"
                                    data-name="Path 126"
                                    d="M1989.045,772.831h0a1.189,1.189,0,0,1-.581,1.578l-21.029,9.707a1.189,1.189,0,0,1-1.578-.581h0a1.189,1.189,0,0,1,.581-1.578l21.029-9.707A1.189,1.189,0,0,1,1989.045,772.831Z"
                                    transform="translate(-1954.403 -747.565)"
                                    fill="#fffcf5"
                                  />
                                  <path
                                    id="Path_127"
                                    data-name="Path 127"
                                    d="M1976.622,745.919h0a1.189,1.189,0,0,1-.581,1.578l-21.029,9.707a1.189,1.189,0,0,1-1.578-.581h0a1.189,1.189,0,0,1,.581-1.578l21.029-9.707A1.189,1.189,0,0,1,1976.622,745.919Z"
                                    transform="translate(-1944.249 -725.568)"
                                    fill="#fffcf5"
                                  />
                                  <path
                                    id="Path_128"
                                    data-name="Path 128"
                                    d="M1964.2,719.007h0a1.189,1.189,0,0,1-.581,1.578l-21.029,9.707a1.189,1.189,0,0,1-1.578-.581h0a1.189,1.189,0,0,1,.581-1.578l21.029-9.707A1.189,1.189,0,0,1,1964.2,719.007Z"
                                    transform="translate(-1934.095 -703.571)"
                                    fill="#fffcf5"
                                  />
                                  <path
                                    id="Path_129"
                                    data-name="Path 129"
                                    d="M1951.777,692.095h0a1.189,1.189,0,0,1-.581,1.578l-21.029,9.707a1.189,1.189,0,0,1-1.578-.581h0a1.189,1.189,0,0,1,.581-1.578l21.029-9.707A1.189,1.189,0,0,1,1951.777,692.095Z"
                                    transform="translate(-1923.942 -681.574)"
                                    fill="#fffcf5"
                                  />
                                  <path
                                    id="Path_130"
                                    data-name="Path 130"
                                    d="M1939.354,665.184h0a1.189,1.189,0,0,1-.582,1.578l-21.029,9.707a1.189,1.189,0,0,1-1.578-.581h0a1.189,1.189,0,0,1,.581-1.578l21.029-9.707A1.189,1.189,0,0,1,1939.354,665.184Z"
                                    transform="translate(-1913.788 -659.578)"
                                    fill="#fffcf5"
                                  />
                                  <path
                                    id="Path_131"
                                    data-name="Path 131"
                                    d="M1926.931,638.271h0a1.189,1.189,0,0,1-.581,1.578l-21.029,9.707a1.189,1.189,0,0,1-1.578-.581h0a1.189,1.189,0,0,1,.581-1.578l21.029-9.707A1.189,1.189,0,0,1,1926.931,638.271Z"
                                    transform="translate(-1903.634 -637.581)"
                                    fill="#fffcf5"
                                  />
                                </g>
                                <path
                                  id="Path_132"
                                  data-name="Path 132"
                                  d="M1722.2,787.187l3.265,7.074-24.328,11.23a3.9,3.9,0,0,1-5.169-1.9h0a3.9,3.9,0,0,1,1.9-5.169Z"
                                  transform="translate(-1695.606 -746.904)"
                                  fill="#e6cc89"
                                />
                              </g>
                              <rect
                                id="Rectangle_10"
                                data-name="Rectangle 10"
                                width="13.863"
                                height="10.562"
                                transform="translate(99.279 18.655) rotate(-114.778)"
                                fill="#ebc86e"
                              />
                            </g>
                            <path
                              id="Path_133"
                              data-name="Path 133"
                              d="M2253.521,103.09c26.554-9.094,54.981-2.257,86.907,20.9,4.852,3.52,10.566,8.942,17.182,15.221,16.974,16.107,38.1,36.153,56.6,34.883,7.078-.486,13.158-4.023,18.588-10.813,17.741-22.19,12.215-52.33,7.339-78.922q-.352-1.921-.7-3.811c-.422-2.325-.866-4.674-1.313-7.042-3.485-18.45-7.089-37.526-2.675-55.784,2.672-11.048,9.089-19.231,18.559-23.664,10.63-4.977,24.18-4.4,36.248,1.547,12.866,6.339,23.3,18.172,30.162,34.218a116.437,116.437,0,0,1,8.823,45.191c-.085,25.772-5.382,51.374-10.5,76.128l-.257,1.242q-.5,2.431-1.022,4.881c-4.5,21.392-9.16,43.513-.2,64.062,7.26,16.655,21.61,24.048,32.61,23.986l.018,3.25a34.851,34.851,0,0,1-21.413-7.655,47.091,47.091,0,0,1-14.2-18.282c-9.374-21.5-4.609-44.137,0-66.031q.514-2.444,1.019-4.869l.257-1.242c5.09-24.6,10.353-50.036,10.436-75.48a113.115,113.115,0,0,0-8.561-43.9c-6.556-15.324-16.45-26.59-28.61-32.582-11.19-5.513-23.688-6.082-33.433-1.519-8.544,4-14.346,11.429-16.777,21.485-4.253,17.578-.712,36.3,2.709,54.416.449,2.376.894,4.733,1.317,7.065q.343,1.886.7,3.8c5,27.276,10.669,58.192-8,81.538-5.947,7.436-12.979,11.482-20.9,12.026-19.927,1.368-41.626-19.223-59.062-35.768-6.533-6.2-12.175-11.553-16.854-14.948-31.006-22.494-58.465-29.186-83.945-20.46Z"
                              transform="translate(-2151.625 9.299)"
                              fill="#ebc86e"
                            />
                          </g>
                        </g>
                        <g
                          id="Group_21"
                          data-name="Group 21"
                          transform="translate(440.544 147.089)"
                        >
                          <path
                            id="Path_134"
                            data-name="Path 134"
                            d="M1456.1,661.043a5.885,5.885,0,0,1,3.137-3.137,5.983,5.983,0,0,1,4.6,0,5.884,5.884,0,0,1,3.137,3.137,5.984,5.984,0,0,1,0,4.6,5.887,5.887,0,0,1-3.137,3.137,5.984,5.984,0,0,1-4.6,0,5.888,5.888,0,0,1-3.137-3.137,5.984,5.984,0,0,1,0-4.6Zm14.032-92.679q0-5.037-1.926-7.557t-6.668-2.519q-4.742,0-6.668,2.519t-1.926,7.557v30.286l4.445,45.1v-.119a4.128,4.128,0,0,0,1.541,3.082,4.534,4.534,0,0,0,5.186.03,4.016,4.016,0,0,0,1.511-2.993l4.5-45.1Z"
                            transform="translate(-1452.945 -558.289)"
                            fill="#f0d388"
                          />
                        </g>
                        <rect
                          id="Rectangle_11"
                          data-name="Rectangle 11"
                          width="547.278"
                          height="369.726"
                          transform="translate(175.487 45.274)"
                          fill="none"
                        />
                      </g>
                      <text
                        id="No_Internet_Connection_Please_Try_again"
                        data-name="No Internet Connection
Please Try again"
                        transform="translate(683 640)"
                        fill="#ebc86e"
                        fontSize="35"
                        fontFamily="AlbertSans-Bold, Albert Sans"
                        fontWeight="700"
                        letterSpacing="-0.04em"
                      >
                        <tspan x="-174.895" y="0">
                          No Internet Connection
                        </tspan>
                        <tspan x="-122.027" y="42">
                          Please Try again
                        </tspan>
                      </text>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default NoInternet;
